<template>
  <ol class="ol">
    <slot />
  </ol>
</template>

<style lang="scss">
.ol {
  padding: 0;
  list-style-position: inside;
}
</style>
